import React from 'react';
import humanizeDuration from 'humanize-duration';
import Table from '@ui-library/table';
import moment from 'moment';
import { ICloudSourceRunStatus } from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import { DateFormat } from '@ui-library/pickers/DateFormat';
import styled from 'styled-components';
import { TableProps } from 'antd/lib/table';
import { FixMe } from '@utils/types';
import Text from '@ui-library/table/components/text';

const StatusTableWrapper = styled(Table)`
  tr.with-error {
    background-color: rgba(183, 97, 97, 0.1);
  }
`;
interface CloudSourceRunProps extends Partial<TableProps<FixMe>> {
  data?: ICloudSourceRunStatus[];
}
export const humanizeRunDatesDuration = (run: { startedAt: string; finishedAt?: string }) => {
  if (!run.finishedAt || moment(run.startedAt).isAfter(moment(run.finishedAt))) {
    return '-';
  }
  const start = moment(run.startedAt);
  const lastRun = (run.finishedAt && moment(run.finishedAt)) || moment();
  const durationData = moment.duration(lastRun.diff(start)).asMilliseconds();
  return humanizeDuration(durationData, { round: true, largest: 2 });
};

export const sourceStatusCommonColumns = [
  {
    title: 'Started at',
    dataIndex: 'startedAt',
    key: 'startedAt',
    render: (val: string) => <Text name={<DateFormat date={val} />} />,
  },
  {
    title: 'Finished At',
    dataIndex: 'finishedAt',
    key: 'finishedAt',
    render: (val: string, record: FixMe) =>
      (val &&
        (moment(val).isAfter(moment(record.startedAt)) ||
          moment(val).isSame(moment(record.startedAt))) && (
          <Text name={<DateFormat date={val} />} />
        )) ||
      '-',
  },
  {
    title: 'Duration',
    render: (_: FixMe, record: FixMe) => <Text name={humanizeRunDatesDuration(record)} />,
  },
];

const StatusTable = ({ data, columns, ...tableProps }: CloudSourceRunProps) => (
  <StatusTableWrapper
    loading={!data}
    pagination={false}
    columns={columns}
    dataSource={data}
    scroll={{ y: 400 }}
    rowClassName={(record: FixMe) =>
      record.error &&
      record.finishedAt &&
      moment(record.finishedAt).isAfter(moment(record.startedAt))
        ? 'with-error'
        : ''
    }
    {...tableProps}
  />
);

export default StatusTable;
